var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerLegs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "53px",
    viewBox: "0 0 40 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lower Legs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-21",
    transform: "translate(-68.000000, -274.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5,274 C87.0172991,279.770981 86.7939434,290.559078 85.8299328,306.36429 L85.8299328,327 L85.8299328,327 L75.9466103,327 C75.9466103,320.890294 74.876656,313.142919 72.7367474,303.757875 C70.4087151,294.357784 69.116432,284.438493 68.8598979,274 L86.5,274 Z M107.770975,274 C107.514441,284.438493 106.222158,294.357784 103.894125,303.757875 C101.754217,313.142919 100.684262,320.890294 100.684262,327 L100.684262,327 L90.8009399,327 L90.8009399,327 L90.8009399,306.36429 C89.8369293,290.559078 89.6135736,279.770981 90.1308727,274 L90.1308727,274 Z",
    id: "Lower-Legs"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerLegs);
export default __webpack_public_path__ + "static/media/LowerLegs.ca8df54f86ac4976d774311e6d1aca21.svg";
export { ForwardRef as ReactComponent };